import CallToAction from "components/CallToAction"
import Image from "components/Image"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export default function BenefitsSection({ blok }) {
  return (
    <div className="container-inset lg:pb-24 lg:pt-8">
      <div className="bg-white lg:rounded-4xl">
        <div className="container mx-auto py-10 flex flex-col items-center gap-8">
          <div className="text-center">
            <span className="eyebrow-2 text-purple-bright">{blok.eyebrow}</span>
            <h2 className="text-blue font-bold">{blok.heading}</h2>
          </div>

          <div className="flex flex-col grow lg:flex-row gap-4 lg:justify-around lg:w-full">
            {blok.icons.map((icon) => (
              <div className="flex flex-col items-center" key={icon._uid}>
                <Image
                  unoptimized
                  className="h-auto w-24 aspect-square shrink-0"
                  width="95"
                  height="95"
                  src={icon.icon.filename}
                  alt={`${icon.heading} Icon`}
                />
                <div className="text-blue font-extrabold">{icon.label}</div>
              </div>
            ))}
          </div>

          <div className="text-charcoal lg:text-center lg:max-w-3xl mx-auto leading-6">{richText(blok.content)}</div>
          <CallToAction style="primary" href={getStoryblokLink(blok.button_link)}>
            {blok.button_text}
          </CallToAction>
          <div className="text-charcoal fine-print lg:text-center lg:px-20 lg:max-w-5xl lg:mx-auto">
            {richText(blok.fine_print)}
          </div>
        </div>
      </div>
    </div>
  )
}
